export enum ELandingDetailsAnimationDelay {
  WHOLE_BLOCK = 1500,
}
